import { motion } from "framer-motion";
import { useLang } from "./LangContext";
import { MaskLine } from "./Reveal";
import { IMAGES } from "@/data/content";

export default function Philosophy() {
  const { t } = useLang();
  const words = t.philosophy.quote.split(" ");

  return (
    <section
      data-testid="philosophy-section"
      className="relative overflow-hidden border-t border-border bg-foreground px-6 py-36 text-background md:px-12 md:py-56"
    >
      <img
        src={IMAGES.texture}
        alt=""
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-15 grayscale"
      />
      <div className="relative z-10 mx-auto max-w-5xl text-center">
        <span className="label text-background/50">06 — Philosophy</span>
        <h2 className="mt-10 font-display text-3xl font-medium leading-[1.05] tracking-tight sm:text-4xl md:text-6xl">
          {words.map((w, i) => (
            <motion.span
              key={i}
              className="mr-[0.25em] inline-block"
              initial={{ opacity: 0.12, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 0.6, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
            >
              {w}
            </motion.span>
          ))}
        </h2>
        <div className="mx-auto mt-12 max-w-xl overflow-hidden">
          <MaskLine delay={0.2}>
            <p className="text-base leading-relaxed text-background/70 md:text-lg">
              {t.philosophy.sub}
            </p>
          </MaskLine>
        </div>
        <p className="mt-10 font-mono text-[0.7rem] uppercase tracking-[0.22em] text-accent">
          {t.philosophy.small}
        </p>
      </div>
    </section>
  );
}
